// extracted by mini-css-extract-plugin
export default {"footerDesktop":"FooterStyle_footerDesktop__av14+","divWrapper":"FooterStyle_divWrapper__nhz4Y","brDisplay":"FooterStyle_brDisplay__7G-x9"};